const ENCODED_FILE_NAME = /filename\*=UTF-8''([^;]+)/i
const PLAIN_FILE_NAME = /filename="?([^";]+)"?/i

/** The name in Content-Disposition, also when it comes encoded (filename*=UTF-8''…) */
export const getDownloadFileName = (headers: Record<string, unknown>): string | null => {
  const disposition = String(headers['content-disposition'] ?? '')
  const encoded = ENCODED_FILE_NAME.exec(disposition)
  if (encoded) {
    return decodeURIComponent(encoded[1])
  }
  return PLAIN_FILE_NAME.exec(disposition)?.[1] ?? null
}
